import DatePicker from 'vue2-datepicker';
import commonHelper from '@/app/utility/common.helper.utility';
import appStrings from '@/app/utility/string.utility';
import addIsdRevenue from './addIsdRevenue';
import editIsdRevenue from './editIsdRevenue';

export default {
  name: 'ISDRevenue',
  watch: {
    currentPage: function() {
      this.getIsdRevenueData();
    },
    perPage: function() {
      this.currentPage = 1;
      this.getIsdRevenueData();
    }
  },
  components: { DatePicker, addIsdRevenue, editIsdRevenue },
  data() {
    return {
      loader: false,
      perPage: commonHelper.perPageRecord,
      pageOptions: commonHelper.getPageOption(),
      financialYear: {
        text: null,
        value: null
      },
      legalEntity: {
        text: null,
        value: null
      },

      totalRows: null,
      currentPage: 1,
      showValueSetModal: false,
      parent_value_set_id: null,
      isdRevenueData: [],
      isdRevenueFields: [
        // {
        //   key: 'add',
        //   stickyColumn: true,
        //   class: 'text-center'
        // },
        // {
        //   key: 'remove',
        //   stickyColumn: true,
        //   class: 'text-center'
        // },
        {
          key: 'finYear',
          label: ' Financial Year'
        },
        {
          key: 'OrgName',
          label: 'Legal Entity'
        },
        {
          key: 'freezeFlag',
          label: 'Freeze '
        }
      ],
      currentFinancialYear: new Date().getFullYear(),
      showAddIsdRevenueModal: false,
      accessButtons: {
        deleteAllow: false,
        downloadAllow: false,
        uploadAllow: false,
        editAllow: true,
        addAllow: true,
        printAllow: false,
        approvalAllow: false
      },
      showEditIsdRevenueModal: false,
      editMode: false,
      rowData: null
    };
  },
  mounted() {
    this.unsubscribe = this.$store.subscribe((mutation, state) => {
      if (mutation.type === 'shared/setActionName') {
        const actionName = state.shared.actionName;
        if (actionName === 'add' && !this.showEditIsdRevenueModal) {
          this.showAddIsdRevenueModal = true;
        }
        if (actionName === 'update') {
          this.editMode = true;
        }
      }
    });
  },
  methods: {
    openValueSetModal(vsetCode) {
      this.vsetCode = vsetCode;
      this.showValueSetModal = true;
      if (this.vsetCode === appStrings.VALUESETTYPE.GST_FIRST_PARTY_GSTN) {
        this.parent_value_set_id = this.legalEntity.value;
      }
      this.setTimeVsetCode = setTimeout(() => {
        const vSetData = {
          valueSetName: vsetCode,
          multiFlag: null
        };
        this.eventBus.$emit('valueSetCode', vSetData);
      }, 0);
    },
    closeValueSetModal() {
      this.showValueSetModal = false;
    },
    selectedvalueSet(item) {
      if (this.vsetCode === appStrings.VALUESETTYPE.LEGAL_ENTITY_LIST) {
        this.legalEntity = {
          text: item.value_code,
          value: item.value_set_dtl_id
        };
      } else if (this.vsetCode === appStrings.VALUESETTYPE.CUSTOM_FY) {
        this.financialYear = {
          text: item.value_meaning,
          value: item.value_code
        };
      }
    },
    clearVsetValues(vsetCode) {
      if (vsetCode === 'LEGAL_ENTITY_LIST') {
        this.legalEntity = {
          text: null,
          value: null
        };
      } else if (vsetCode === 'CUSTOM_FY') {
        this.financialYear = {
          text: null,
          value: null
        };
      }
    },
    showHideIsdRevenueModal(flag) {
      this.showAddIsdRevenueModal = flag;
    },

    getIsdRevenueData() {
      if (this.financialYear.value === null) {
        this.$bvToast.toast('Please Select mandatory Fields', {
          title: 'Alert',
          variant: 'danger',
          solid: true
        });
      } else {
        const payload = {
          _page: this.currentPage - 1,
          _limit: this.perPage,
          fin_year: this.financialYear.value,
          le_id: this.legalEntity.value
        };
        this.loader = true;
        this.$store
          .dispatch('isdRevenue/getIsdRevenueData', payload)
          .then(response => {
            this.loader = false;
            if (response.status === 200) {
              this.isdRevenueData = response.data.data.page;
              this.totalRows = response.data.data.total_elements;
              this.isdRevenueData.map(data => {
                data.freezeFlag = data.freezeFlag === 'Y' ? true : false;
                return data;
              });
            }
          })
          .catch(() => {
            this.loader = false;
          });
      }
    },
    clearFilters() {
      (this.financialYear = {
        text: null,
        value: null
      }),
        (this.legalEntity = {
          text: null,
          value: null
        }),
        (this.isdRevenueData = []);
    },
    rowSelected(item) {
      this.showEditIsdRevenueModal = true;
      this.rowData = item;
    },
    showHideEditIsdRevenueModal(flag) {
      this.showEditIsdRevenueModal = flag;
    }
  },
  beforeDestroy() {
    this.unsubscribe();
  }
};
